var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button is-black skip-to-main",attrs:{"href":""},on:{"click":_vm.skipToMain}},[_vm._v(" Skip to content ")])
}
var staticRenderFns = []

export { render, staticRenderFns }